import { render, staticRenderFns } from "./christian-moueix-dominus.vue?vue&type=template&id=f6c3760e&scoped=true"
import script from "./christian-moueix-dominus.vue?vue&type=script&lang=js"
export * from "./christian-moueix-dominus.vue?vue&type=script&lang=js"
import style0 from "./christian-moueix-dominus.vue?vue&type=style&index=0&id=f6c3760e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c3760e",
  null
  
)

export default component.exports